/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:9318fd26-9871-45fd-8827-41d4a3811ff1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_bxzYWyOND",
    "aws_user_pools_web_client_id": "5dor1qe8j37aiftqv4i3mpupel",
    "oauth": {},
    "aws_user_files_s3_bucket": "eh-map-2020-temp2020-master",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
